import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Exclamation({ color = 'icon.white', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 16 15' {...props}>
      <Path
        d='M7.99912 8.02564V5.46094'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M7.99844 10.0933C7.90381 10.0933 7.827 10.1701 7.82769 10.2647C7.82769 10.3594
                7.90449 10.4362 7.99913 10.4362C8.09376 10.4362 8.17056 10.3594 8.17056
                10.2647C8.17056 10.1701 8.09376 10.0933 7.99844 10.0933'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.39129 1.87048L14.6434 11.0623C15.2538 12.1307 14.4823 13.4603 13.2521
                13.4603H2.74775C1.51683 13.4603 0.745366 12.1307 1.35637 11.0623L6.60852
                1.87048C7.22364 0.793172 8.77618 0.793172 9.39129 1.87048Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
    </IconBase>
  )
}

Exclamation.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Exclamation
